import './Dashboard.css'
import { Button } from '@mui/material'
import { useEffect, useState } from 'react';
// Components
import IonicPageWrapper from '../../components/IonicPageWrapper/IonicPageWrapper'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
// ICONs & SVGs
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import lightIcon from '../../imgs/light_img.svg'
import cameraIcon from '../../imgs/security-camera.png'
import { useHistory } from 'react-router';
import { useSnackbar } from "notistack";
import axios from "axios";


function Dashboard() {
    const { enqueueSnackbar } = useSnackbar();
    const [subadmin, setSubadmin] = useState('all');
    const [user, setUser] = useState([]);
    const auth = localStorage.getItem("authToken");
    const user_id = localStorage.getItem("user_id");
    const history = useHistory();
    const isloggedin = localStorage.getItem("loggedIn");
    useEffect(() => {
        if(!isloggedin)
        {
            history.push('/login'); 
            window.location.reload(); 
        }
    }, []);
    const onLightClick = () => {
        // history.push('/light');
        const lightData = { user, subadmin };
        history.push('/light', lightData);
        window.location.reload();
    }
    const onCameraClick = () => {
        history.push('/camera');
    }
    const handleChange = (event) => {
        setSubadmin(event.target.value);
    };
    const fetchAllSubAdmins = async () => {
        await axios.post(`${process.env.REACT_APP_BASE_URL}/admin/users/all-subAdmins`, { user_id }, {
            headers: { Authorization: `Bearer ${auth}` }
        })
            .then(res => {
                if (!res.data?.success) return enqueueSnackbar('Error Fetching Sub Admins !!!', { variant: 'error' })
                setUser(res.data.users);
            })
            .catch(err => {
                console.log(err);
                enqueueSnackbar('Error Fetching Areas !!!', { variant: 'error' })
            })
    }
    useEffect(() => {
        fetchAllSubAdmins();
    }, [])
    console.log(subadmin);
    return (
        <IonicPageWrapper headerTitle='Dashboard' showLogout={true} >
            <div id="dashboardControl">
                {
                    (localStorage.getItem("role") === "admin") ?
                        (
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Select Subadmin</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    name='subadmin'
                                    value={subadmin}
                                    label="Select Subadmin"
                                    onChange={handleChange}
                                >
                                    {/* <MenuItem value={"Ankit"}>Ankit</MenuItem>
                                    <MenuItem value={"Mohit"}>Mohit</MenuItem> */}
                                    <MenuItem value={"all"}>All</MenuItem>
                                    {user?.map((c, i) => (
                                        <MenuItem value={c?.name} key={i}>
                                        {/* <MenuItem value={c?.name} key={i}> */}
                                        {c?.name}
                                      </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        ) :
                        null
                }
                <div className="dashboard_cardCont">
                    <DashboardCard no_camera="Lights" icon={lightIcon} click={onLightClick} />
                    <DashboardCard no_camera="Camera" icon={cameraIcon} click={onCameraClick} />
                </div>
            </div>
        </IonicPageWrapper>
    )
}

export default Dashboard

const DashboardCard = ({ no_camera, icon, click }) => (
    <div className="dashboard_card">
        <section className='dashboard_card_content' onClick={click}>
        <div className='title'>
            {no_camera}
        </div>
            <img src={icon} alt="" />
        </section>
    </div>
)